import React from "react";
import CustomizerComponent from "@gc-npm/components.customizer-component";
import Card from "@/home_components/card";
import Title from "./title";

const FeaturedOffer = ({
  title,
  offerProps,
  offerActivities,
  titleActivity,
  scLogged,
}) => {
  const sizes = "(min-width: 768px) 23vw, 48vw";
  return (
    <section className="featuredOfferCards" data-cy="Section offer cards">
      {scLogged && title && (
        <CustomizerComponent
          name={titleActivity}
          Component={Title}
          componentProps={title}
          componentName="OfferTitle"
        />
      )}
      {!scLogged && <Title {...title} />}

      <div className="container featuredOfferCards--content">
        <div className="row">
          {offerProps &&
            Array.isArray(offerProps) &&
            offerProps.map((offer, i) => {
              if (scLogged) {
                return (
                  <div
                    className="col-xs-6 col-sm-6 col-md-3 col-lg-3 featuredOfferCards--content_cards"
                    key={`card-${i}`}
                  >
                    <CustomizerComponent
                      name={offerActivities[i]}
                      Component={Card}
                      componentProps={offer}
                      commonProps={{ sizes: sizes }}
                      componentName={`OfferCard${i + 1}`}
                      skeletonClassName="skeleton-banner-card"
                    />
                  </div>
                );
              }

              return (
                <div
                  className="col-xs-6 col-sm-6 col-md-3 col-lg-3 featuredOfferCards--content_cards"
                  key={`card-${i}`}
                >
                  <Card {...offer} sizes={sizes} />
                </div>
              );
            })}
        </div>
      </div>
      <style jsx>
        {`
          .featuredOfferCards {
            padding: 1rem 0;
            background-color: #fffaf5;
            justify-content: center;
            flex-direction: column;
            line-height: 29px;
          }
          .featuredOfferCards :global(h1) {
            letter-spacing: -0.5px;
            padding-bottom: 1rem;
          }
          .featuredOfferCards :global(a):focus-visible {
            outline-offset: 0.125rem;
          }
          .featuredOfferCards
            :global(.card.layout-product .card-container--label) {
            min-height: auto;
          }
          .featuredOfferCards :global(.card) {
            padding: 0;
          }
          .featuredOfferCards :global(.card) :global(.card-container) {
            gap: 0;
          }
          .featuredOfferCards
            :global(.card)
            :global(.card-container--image .custom-image) {
            border-radius: 0;
          }
          .featuredOfferCards :global(.card) :global(.card-container--info) {
            padding: 1.5rem;
            gap: 1rem;
          }
          .featuredOfferCards :global(.card) :global(.card-container--image) {
            max-width: none;
            aspect-ratio: unset;
          }
          .featuredOfferCards :global(.card) :global(img) {
            object-fit: cover !important;
          }
          .featuredOfferCards--content {
            line-height: normal;
          }
          .featuredOfferCards--content_cards {
            position: relative;
            display: flex;
            flex-wrap: wrap;
          }
          .featuredOfferCards--content .row {
            grid-row-gap: 0.75rem;
            align-items: stretch;
          }

          .featuredOfferCards :global(.card) :global(.card-container) {
            gap: 0;
            flex-direction: column;
            align-items: flex-start;
          }
          .featuredOfferCards :global(.card) :global(.card-container--image) {
            padding-top: 75%;
          }
          .featuredOfferCards  :global(.card-content) :global(.card-content--price) :global(.price) {
              padding-right: 0.75rem;
          }
          .featuredOfferCards :global(.card) :global(img) {
            object-fit: cover !important;
          }
          .featuredOfferCards--content {
            padding-top: 1rem;
            padding-bottom: 1rem;
          }
          .featuredOfferCards--content .row {
            grid-row-gap: 1rem;
            grid-gap: 1rem;
          }
          .featuredOfferCards
            :global(.card.layout-product .card-container--label) {
            min-height: 2rem;
          }
          .featuredOfferCards
            :global(.card .layout-tariff)
            :global(.card-container--info)
            :global(.card-container--label) {
            min-height: auto;
          }

          @media screen and (min-width: 1280px) {
            .featuredOfferCards {
              padding-top: 1.5rem;
            }
            .featuredOfferCards--content {
              padding-top: 1.5rem;
              padding-bottom: 1.5rem;
            }
            .featuredOfferCards--content .row {
              grid-row-gap: 1.5rem;
            }
          }
        `}
      </style>
    </section>
  );
};

export default FeaturedOffer;
